import React from 'react'
import { ProductLights } from '../_shared/ProductLights'
import type { LightSpec, LightsProps } from '../types'

const rig: LightSpec[] = [
  { type: 'spot', position: [-220, 500, -200], target: [0, 100, 0], intensity: 1, angle: 0.8, penumbra: 0.4, distance: 0, decay: 0, color: '#c8dcff', castShadow: true },
  { type: 'spot', position: [220, 200, 180], target: [0, 100, 0], intensity: 1, angle: 0.8, penumbra: 0.4, distance: 0, decay: 0, color: '#ffb46b' },
  { type: 'spot', position: [0, 700, 200], target: [0, 80, 0], intensity: 1, angle: 0.5, penumbra: 0.5, distance: 0, decay: 0, color: '#ffffff' },
  { type: 'spot', position: [-200, 300, -400], target: [0, 200, 200], intensity: 2, angle: 1, penumbra: 1, distance: 0, decay: 0, castShadow: true, shadowRadius: 4, color: '#ffb46b' },
]

export const Lights: React.FC<LightsProps> = (props) => (
  <ProductLights rig={rig} {...props} />
)
